/**
 * Recharts category axes list the first row at the TOP of a vertical-layout chart.
 * With 1–few rows the bars look centered in the plot. Prepend invisible placeholders
 * so real categories sit at the bottom (same idea for scatter category Y-axes).
 *
 * @param {object[]} rows
 * @param {{ minSlots?: number, categoryKey: string, valueKeys?: string[] }} options
 * @returns {object[]}
 */
export function padCategoriesToBottom(rows, {
  minSlots = 5,
  categoryKey,
  valueKeys = [],
} = {}) {
  const list = Array.isArray(rows) ? rows : [];
  if (!categoryKey || list.length === 0 || list.length >= minSlots) {
    return list;
  }

  const pads = Array.from({ length: minSlots - list.length }, (_, index) => {
    const pad = {
      [categoryKey]: `\u200b${index}`,
      __pad: true,
    };
    valueKeys.forEach((key) => {
      pad[key] = null;
    });
    return pad;
  });

  return [...pads, ...list];
}

/** Hide placeholder category labels on the axis. */
export function categoryTickLabel(value) {
  if (value == null) return '';
  const text = String(value);
  if (text.length === 0 || text.charCodeAt(0) === 0x200b) return '';
  return text;
}

/** True when the active tooltip / bar payload is a padding row. */
export function isCategoryPadPayload(payload) {
  const row = Array.isArray(payload) ? payload[0]?.payload : payload?.payload;
  return Boolean(row?.__pad);
}
